function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck
import React from "react";
import { Grid, Button, Typography, TextField, Card } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import Select from "react-select";
import UserProfileBasicBlockController from "./UserProfileBasicController";
const options = [{
  value: "chocolate",
  label: "Chocolate"
}, {
  value: "strawberry",
  label: "Strawberry"
}, {
  value: "vanilla",
  label: "Vanilla"
}];
const customStyles = {
  control: base => _objectSpread(_objectSpread({}, base), {}, {
    height: 57,
    minHeight: 35
  })
};
export class UserProfileBasicBlock extends UserProfileBasicBlockController {
  constructor(props) {
    super(props);
    //Customizable Area Start
    //Customizable Area End
  }
  render() {
    const {
      navigation,
      classes
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
      className: classes.mainCard
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        padding: "20px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text1
    }, "User Profile")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "First Name",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Last Name",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Email",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      label: "Mobile",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Select, {
      id: "selectDevices",
      options: this.state.deviceList,
      isMulti: true,
      name: "Devices",
      styles: customStyles,
      placeholder: /*#__PURE__*/React.createElement("span", {
        className: classes.text2
      }, "Select Device"),
      onChange: this.handleSubDeviceChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Select, {
      options: options,
      styles: customStyles,
      placeholder: /*#__PURE__*/React.createElement("span", {
        className: classes.text2
      }, "Select Shift Timing")
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      className: classes.saveBtn
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.saveBtnText
    }, "Save"))))));
  }
}

// Customizable Area Start
const styles = () => ({
  text1: {
    fontSize: "20px"
  },
  text2: {
    fontFamily: "Poppins"
  },
  saveBtn: {
    width: "166px",
    height: "56px",
    backgroundColor: "#141618",
    borderRadius: "15px"
  },
  saveBtnText: {
    opacity: 1,
    fontWeight: 800,
    color: "rgba(255, 255, 255, 1)",
    fontFamily: "Poppins",
    fontSize: "14px"
  },
  mainCard: {
    boxShadow: "10px 15px 15px #eaeaea, -10px -9px 15px #eaeaea"
  }
});

// Customizable Area End

export default withStyles(styles())(UserProfileBasicBlock);